import { render, staticRenderFns } from "./PolicyActions.vue?vue&type=template&id=6871ac03"
import script from "./PolicyActions.vue?vue&type=script&lang=js"
export * from "./PolicyActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports